class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(
      (entries, observer) => this.handleIntersection(entries, observer),
      { rootMargin: '0px 0px 600px 0px' }
    ).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          const sliderEl = this.querySelector('component-collection-slider');
          if (sliderEl && typeof sliderEl.connectedCallback === 'function') {
            sliderEl.connectedCallback();
          }
          if (typeof alignProductCardsHeight === 'function') {
            alignProductCardsHeight();
          }
        }
      })
      .catch(() => {});
  }
}
customElements.define('product-recommendations', ProductRecommendations);